export const agentFields = {
  addagent: {
    email: 'email',
    subRoleId: 'subRoleId',
  },
};
